import { useState } from 'react';

const faqs = [
  {
    question: '什么是欧美无码正版内容平台？',
    answer: '欧美无码正版内容平台是指获得合法授权、提供高清无码成人内容的专业流媒体服务。这些平台通常提供4K/8K超清画质、正版授权内容、安全的支付方式和完善的隐私保护措施。与盗版网站不同，正版平台内容质量有保障，且用户信息安全有更好的保护。',
  },
  {
    question: '如何选择适合自己的欧美无码平台？',
    answer: '选择平台时建议从以下几个维度考虑：1）内容偏好（高清画质、VR体验、直播互动等）；2）预算范围（月付$12.99-$34.99不等）；3）使用设备（PC端、移动端还是VR设备）；4）是否需要多设备共享。建议先利用免费试用期体验不同平台，再做出最终选择。',
  },
  {
    question: '访问欧美无码平台需要注意哪些安全问题？',
    answer: '安全访问建议：1）使用信誉良好的VPN服务保护隐私；2）使用虚拟信用卡或加密货币进行支付；3）使用独立邮箱注册；4）定期清理浏览记录和缓存；5）避免在公共WiFi下访问；6）确认平台的合法性和信誉度。请务必遵守当地法律法规。',
  },
  {
    question: '欧美无码平台的画质标准是什么？',
    answer: '主流平台的画质标准从1080P全高清到8K超高清不等。UltraPass和CrystalStream已支持8K画质，PrimeFlix和LuxePlay支持4K HDR。选择画质时需要考虑：1）网络带宽（4K需要25-50Mbps，8K需要50-100Mbps）；2）显示设备是否支持对应分辨率；3）存储空间是否充足（如需下载）。',
  },
  {
    question: '平台订阅可以退款吗？',
    answer: '大多数平台提供免费试用期（1-7天），试用期内取消不会产生费用。正式订阅后，退款政策因平台而异：部分平台支持7天无理由退款，部分平台不支持退款。建议订阅前仔细阅读平台的退款政策，并充分利用免费试用期进行体验。',
  },
  {
    question: '可以在多个设备上使用同一个账号吗？',
    answer: '这取决于具体平台的设备政策。PrimeFlix支持最多5个设备同时使用，UltraPass支持3个设备，PureVision支持2个设备。部分平台还提供家庭/朋友共享计划，可以以更优惠的价格实现多设备使用。建议在注册前查看平台的设备使用政策。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs font-semibold text-accent-500 uppercase tracking-wider">
            常见问题
          </span>
          <h2 className="mt-3 text-2xl md:text-3xl font-heading font-bold text-foreground-800">
            关于欧美无码平台的常见疑问
          </h2>
          <p className="mt-3 text-sm text-foreground-500">
            为您解答关于欧美无码平台选择、使用和安全的常见问题
          </p>
        </div>
        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-background-200/50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-200/30 transition-colors duration-200"
              >
                <span className="text-sm font-semibold text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 flex-shrink-0 rounded-full bg-background-200/50 flex items-center justify-center transition-transform duration-300 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}>
                  <i className="ri-arrow-down-s-line text-foreground-500 text-sm"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-500 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}